import React, { useState } from 'react';

const StackerEducatorTool = () => {
  const [topic, setTopic] = useState('');
  const [gradeLevel, setGradeLevel] = useState('');
  const [numSections, setNumSections] = useState(3);
  const [outline, setOutline] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setOutline('');

    // Placeholder for API call to the Hub
    // In a real scenario, you'd fetch the JWT from Supabase Auth
    // and include it in the Authorization header.
    const dummyJwtToken = "YOUR_DUMMY_JWT_TOKEN"; // Replace with actual token logic

    try {
      const response = await fetch('http://localhost:3000/api/educator/resource-outline', { // Replace with deployed Hub URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${dummyJwtToken}`
        },
        body: JSON.stringify({ topic, grade_level: gradeLevel, num_sections: numSections })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to generate outline');
      }

      const data = await response.json();
      setOutline(data.outline);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      <h1>Hello from Stacker!</h1>
      <h2>Educational Resource Outline Generator</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
        <label>
          Topic:
          <input
            type="text"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
        </label>
        <label>
          Grade Level:
          <input
            type="text"
            value={gradeLevel}
            onChange={(e) => setGradeLevel(e.target.value)}
            required
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
        </label>
        <label>
          Number of Sections:
          <input
            type="number"
            value={numSections}
            onChange={(e) => setNumSections(parseInt(e.target.value))}
            min="1"
            required
            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
          />
        </label>
        <button type="submit" disabled={loading} style={{ padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          {loading ? 'Generating...' : 'Generate Outline'}
        </button>
      </form>

      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {outline && (
        <div style={{ border: '1px solid #eee', padding: '15px', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>
          <h3>Generated Outline:</h3>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{outline}</pre>
        </div>
      )}
    </div>
  );
};

export default StackerEducatorTool;